import React from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';
import { Select } from '@sopranodesign/pulse-components';

const format = ({ id, name }) => ({ label: name, value: id });

const ImportSelect = ({ value, ...props }) => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  const selected =
    isSuccess && value ? data.data.find(item => item.id === value) : null;

  return (
    <Select
      isClearable
      isLoading={isLoading}
      options={
        isSuccess
          ? data.data.filter(({ sections }) => sections.length > 0).map(format)
          : []
      }
      value={selected ? format(selected) : null}
      {...props}
    />
  );
};

ImportSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ImportSelect;
